"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferredLocale = exports.PreferredLocaleStore = void 0;
/*
 * Copyright '2021' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
const supported_locales_utility_1 = require("./supported-locales-utility");
const local_storage_store_1 = require("./local-storage/local-storage.store");
const lwp_cookie_store_1 = require("./lwp-cookie/lwp-cookie.store");
class PreferredLocaleStore {
    constructor() {
        this.localeStorageStore = new local_storage_store_1.LocalStorageStore();
        this.lwpCookieStore = new lwp_cookie_store_1.LwpCookieStore();
        this.defaultLocaleChangedReloadHandler = (oldLocale, newLocale) => undefined;
        this.registeredLocaleChangedReloadHandler = this.defaultLocaleChangedReloadHandler;
        this.cachedLocale = '';
    }
    static getInstance() {
        if (!PreferredLocaleStore.instance) {
            PreferredLocaleStore.instance = new PreferredLocaleStore();
        }
        return PreferredLocaleStore.instance;
    }
    get defaultLocale() {
        return this.localeStorageStore.defaultLocale;
    }
    setLocale(locale, permanent = true, force = false) {
        if (!supported_locales_utility_1.SupportedLocales.isLocaleSupported(locale)) {
            return;
        }
        locale = supported_locales_utility_1.SupportedLocales.normalizeLocale(locale);
        if (force || locale !== this.cachedLocale) {
            this.cachedLocale = locale;
            if (permanent) {
                this.localeStorageStore.setLocale(this.cachedLocale);
                this.lwpCookieStore.setLocale(this.cachedLocale);
            }
            this.notifyLocaleChanged(locale);
        }
    }
    getLocale() {
        if (!this.cachedLocale) {
            this.cachedLocale = this.localeStorageStore.getLocale() || this.localeStorageStore.defaultLocale;
        }
        return this.cachedLocale;
    }
    onLocaleChanged(subscriber) {
        window.addEventListener(PreferredLocaleStore.LOCALE_CHANGED_EVENT, ((event) => {
            var _a;
            subscriber((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.locale);
        }));
    }
    registerLocaleChangedReloadHandler(localeChangedReloadHandler) {
        if (!localeChangedReloadHandler) {
            this.registeredLocaleChangedReloadHandler = this.defaultLocaleChangedReloadHandler;
        }
        this.registeredLocaleChangedReloadHandler = localeChangedReloadHandler;
    }
    triggerLocaleChangedReload(oldLocale, newLocale) {
        this.registeredLocaleChangedReloadHandler(oldLocale, newLocale);
    }
    notifyLocaleChanged(locale) {
        window.dispatchEvent(new CustomEvent(PreferredLocaleStore.LOCALE_CHANGED_EVENT, {
            detail: {
                locale: locale
            }
        }));
    }
}
exports.PreferredLocaleStore = PreferredLocaleStore;
PreferredLocaleStore.LOCALE_CHANGED_EVENT = 'locale-changed-event';
exports.PreferredLocale = PreferredLocaleStore.getInstance();
//# sourceMappingURL=preferred-locale-store.js.map